/* eslint-disable react-hooks/exhaustive-deps */
import { Box, FormControl, FormLabel, Text } from '@chakra-ui/react';
import { ErrorMessage, Field } from 'formik';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import JoditEditor from 'jodit-react';
import jodit from '../../../utils/jodit';
import './style.css';

const RichTextEditorField = ({ name = null, label = null, disabled = false, required = false, showToolbar = false, minHeight = 24 }) => {
	const { t } = useTranslation();

	const config = useMemo(
		() => ({
			minHeight,
			showPlaceholder: false,
			toolbarSticky: false,
			toolbarAdaptive: false,
			toolbarInlineForSelection: showToolbar ? false : true,
			inline: false,
			readonly: disabled,
			toolbar: showToolbar,
			statusbar: false,
			buttons: jodit?.buttons,
			controls: jodit?.controls,
		}),
		[showToolbar, disabled]
	);

	return (
		<Field name={name}>
			{({ field, meta, form }) => {
				return (
					<Box mb={4}>
						<FormControl>
							<FormLabel>
								{t(label)}
								{required && <span style={{ color: 'red' }}>*</span>}
							</FormLabel>
							<JoditEditor value={field?.value} config={config} tabIndex={1} onChange={(newContent) => form?.setFieldValue(name, newContent)} />
							{meta.touched && meta.error && (
								<ErrorMessage
									name={name}
									children={(errorMessage) => (
										<Text textAlign="left" mt={1} color="red.400" fontSize="12px">
											{t(name)} {t('is')} {t(errorMessage)}
										</Text>
									)}
								/>
							)}
						</FormControl>
					</Box>
				);
			}}
		</Field>
	);
};

export default RichTextEditorField;
